export default {
    recordDetails: {
        enableInventory: "Paganahin ang imbentaryo",
        inventoryDisabled: "Hindi aktibo ang pagsubaybay sa imbentaryo",
        inventoryEnabled: "Naka-enable na ang imbentaryo",
        inventorySaved: "Na-save ang pag-aayos ng imbentaryo",
        itemTitle: "Mga detalye ng item",
        expenseTitle: "Mga detalye ng gastos",
        timeTitle: "Mga detalye ng tala ng oras",
        information: "Mga detalye",
        receipt: "Resibo",
        inventoryHistory: "Kasaysayan ng imbentaryo",
        inventoryLoadFailed: "Hindi ma-load ang kasaysayan ng imbentaryo.",
        noInventory: "Wala pang galaw sa imbentaryo",
        loadFailed: "Hindi ma-load ang mga detalye.",
        deleteConfirm: "Burahin ang talang ito?",
        deleted: "Nabura ang tala"
    },
    common: {
        appName: 'Swift Invoice',
        back: 'Bumalik',
        cancel: 'Kanselahin',
        email: 'Email',
        password: 'Password',
        or: 'o',
        change: 'Palitan',
        delete: 'Tanggalin',
        save: 'I-save',
        edit: 'I-edit',
        add: 'Idagdag',
        close: 'Isara',
        date: 'Petsa',
        total: 'Kabuuan',
        status: 'Status',
        amount: 'Halaga',
        quantity: 'Dami',
        rate: 'Rate',
        tax: 'Buwis',
        discount: 'Diskwento',
        note: 'Tala',
        notes: 'Mga Tala',
        noData: 'Walang data',
        description: 'Paglalarawan',
        client: 'Kliyente',
        item: 'Item',
        items: 'Mga Item',
        type: 'Uri',
        category: 'Kategorya',
        phone: 'Telepono',
        name: 'Pangalan',
        subject: 'Paksa',
        saveAndClose: 'I-save at Isara',
        saveAndSendEmail: 'I-save at Magpadala ng Email',
        sendEmail: 'Magpadala ng email',
        send: 'Ipadala',
        print: 'I-print',
        moreActions: 'Higit pang mga aksyon',
        preparingPdf: 'Inihahanda ang PDF...',
        pdfPreparationFailed: 'Hindi maihanda ang PDF',
        warning: 'Babala',
        ok: 'OK',
        uploadSuccess: 'tagumpay ang pag-upload',
        saveSuccess: 'tagumpay ang pag-save',
        deleteSuccess: 'tagumpay ang pagtanggal',
        deleteFailed: 'bigo ang pagtanggal',
        saveFailed: 'bigo ang pag-save',
        loadFailed: 'bigo ang pag-load',
        systemError: 'error sa sistema',
        sendSuccess: 'tagumpay ang pagpapadala',
        updateSuccess: 'tagumpay ang pag-update',
        unsavedChangesMsg: 'Mayroon kang mga hindi na-save na pagbabago. Gusto mo ba itong i-save o itapon?',
        saveChangesTitle: 'I-save ang mga pagbabago?',
        confirmSave: 'I-save',
        discard: 'Itapon',
        validEmail: 'Mangyaring maglagay ng tamang email address',
        deleteFailedMsg: 'bigo ang pagtanggal',
        shipping: 'Pagpapadala',
        attachment: 'Kalakip',
        days: 'Mga Araw',
        excl: '(hindi kasama)',
        incl: '(kasama)',
        of: 'ng',
        batchActions: 'Maramihang aksyon',
        selected: 'napili',
        select: 'Piliin',
        batchDeleteConfirm: 'Burahin ang {count} napiling tala?',
        batchActionSuccess: '{count} tala ang na-update',
        batchActionPartial: '{processed} na-update; {skipped} walang kailangang baguhin',
        batchEmailInvalidRecipients: 'Maglagay ng wastong tatanggap sa bawat dokumento',
        batchEmailSent: '{count} email ang naipadala',
        batchEmailPartial: '{sent} naipadala; {failed} nabigo',
        emailHtmlNotAllowed: 'Hindi maaaring maglaman ng HTML ang paksa o mensahe ng email.'
    },
    emailVerification: {
        title: 'I-verify ang iyong email',
        description: 'Nagpadala kami ng verification code sa iyong login email:',
        codePlaceholder: 'Ilagay ang verification code',
        enterCode: 'Ilagay ang code mula sa email upang magpatuloy.',
        sent: 'Naipadala na ang verification code.',
        resent: 'Naipadala na ang bagong verification code.',
        validFor: 'May bisa ang code sa loob ng 10 minuto.',
        verify: 'I-verify',
        resend: 'Ipadala muli',
        success: 'Na-verify ang email. Ipapadala na ang iyong email.',
        failed: 'Mali o nag-expire na ang verification code.',
        limitReached: 'Naabot na ang limitasyon sa pagpapadala ngayong araw.',
        remaining: '{count} pagpapadala ang natitira ngayong araw',
        contactUs: 'Makipag-ugnayan sa amin'
    },
    login: {
        heroPrefix: 'Matalinong ',
        heroInvoicing: 'Invoicing',
        heroMiddle: ',',
        heroSimplified: 'Pinapadali',
        heroSuffix: ' para sa Iyo.',
        subtitle1: 'Lumikha, magpadala, at pamahalaan ang mga invoice nang walang kahirap-hirap.',
        subtitle2: 'Makatanggap ng bayad nang mas mabilis sa Swift Invoice.',
        feature1Title: 'Propesyonal na mga Invoice',
        feature1Text: 'Lumikha ng magagandang invoice sa loob ng ilang minuto',
        feature2Title: 'Real-time na Pagsubaybay',
        feature2Text: 'Subaybayan ang mga pagbabayad at status ng invoice',
        feature3Title: 'Ligtas at Maaasahan',
        feature3Text: 'Ligtas ang iyong data sa enterprise-grade na seguridad',
        welcomeBack: 'Maligayang pagbabalik',
        signInToContinue: 'Mag-sign in sa iyong account upang magpatuloy',
        enterEmail: 'Ilagay ang iyong email',
        enterPassword: 'Ilagay ang iyong password',
        rememberMe: 'Tandaan ako',
        forgotPassword: 'Nalimutan ang password?',
        signIn: 'Mag-sign in',
        signingIn: 'Nag-sign in…',
        continueWithGoogle: 'Magpatuloy sa Google',
        continueWithApple: 'Magpatuloy sa Apple',
        createAccount: 'Lumikha ng account',
        startUsing: 'Simulang gamitin ang Swift Invoice',
        companyName: 'Pangalan ng kumpanya',
        enterCompanyName: 'Ilagay ang pangalan ng iyong kumpanya',
        alreadyHaveAccount: 'Mayroon nang account? Mag-sign in',
        footerRights: '© 2026 Swift Invoice. Nakalaan ang lahat ng karapatan.',
        termsOfService: 'Mga Tuntunin ng Serbisyo',
        contactUs: 'Makipag-ugnayan sa amin: goodinvoicego@gmail.com',
        betaDialogBody: 'Nakumpleto ng aming koponan ang unang bersyon ng web <br> Ang bersyong ito ay magagamit lamang ng mga gumagamit ng iPhone <br> Papahusayin namin ang web function sa lalong madaling panahon at bubuksan ito para sa lahat <br>',
        ieDialogBody: 'Paumanhin, dahil may problema sa compatibility ang IE browser, hindi pa namin sinusuportahan ang IE browser sa kasalukuyan, kung kailangan mong gamitin, mangyaring i-download',
        resetPasswordTitle: 'I-reset ang password',
        sendResetEmail: 'Magpadala ng reset email',
        resetEmailSent: 'Naipadala na ang email para i-reset ang password. Mangyaring suriin ang iyong inbox.',
        bindingTitle: 'I-link ang umiiral na account',
        bindingHintPrefix: 'May account na ang gumagamit ng email ',
        bindingHintSuffix: ". Ilagay ang password ng account na iyon upang i-link ang iyong Google sign-in.",
        enterAccountPassword: 'Ilagay ang password ng account',
        linkAccount: 'I-link ang account',
        validEmail: 'Mangyaring maglagay ng tamang email address',
        validPassword: 'Dapat ay 6 o higit pang character ang password',
        validCompanyName: 'Mangyaring punan ang pangalan ng iyong kumpanya',
        companyNameTooLong: 'Maaaring magkaroon ng hanggang {max} character ang pangalan ng kumpanya',
        turnstileUnavailable: 'Hindi ma-load ang security check. Pakisubukan muli.',
        turnstileExpired: 'Nag-expire ang security check. Pakikumpleto itong muli.',
        accountDataLoadFailed: 'Na-verify ang account, ngunit hindi ma-load ang data ng negosyo. Pakisubukan muli.'
    },
    account: {
        title: 'Account',
        profile: 'Profile',
        swiftAccount: 'Swift Invoice account',
        connectSocial: 'Ikonekta ang mga social account',
        companyLogo: 'Logo ng kumpanya',
        logoSize: 'Laki ng logo',
        hideBusinessName: 'Itago ang pangalan ng negosyo',
        businessNameSize: 'Laki ng pangalan ng negosyo',
        sizeSmall: 'Maliit',
        sizeNormal: 'Karaniwan',
        sizeBig: 'Malaki',
        addLogo: 'Magdagdag ng logo',
        uploading: 'ina-upload...',
        currentPlan: 'Kasalukuyang plano: Swift {plan}',
        planActiveUntil: 'Aktibo ang plano hanggang {date}',
        sharedWithMobile: 'Ibinahagi sa mobile',
        subscriptionExpired: 'Natapos na ang iyong subscription',
        planNote: 'Mag-log in muli kung hindi pa na-update ang status ng iyong subscription.',
        upgradeToPro: 'Mag-upgrade sa Swift Pro',
        viewPlans: 'Tingnan ang mga subscription plan',
        connecting: 'Kumokonekta…',
        connectGoogle: 'Ikonekta ang Google',
        googleConnected: 'Nakakonekta ang Google',
        googleConnectedWithEmail: 'Nakakonekta ang Google ({email})',
        connectApple: 'Ikonekta ang Apple',
        appleConnected: 'Nakakonekta ang Apple',
        appleConnectedWithEmail: 'Nakakonekta ang Apple ({email})',
        logoUuidMissing: 'Nawawala ang UUID ng logo ng kumpanya',
        googleConnectedToast: 'Nakakonekta ang Google account.',
        appleConnectedToast: 'Nakakonekta ang Apple account.',
        logoUploadEmpty: 'Pumili ng larawan.',
        logoUploadSize: 'Hindi maaaring lumampas sa 10 MB ang larawan.',
        logoUploadType: 'JPEG, PNG, at BMP na larawan lamang ang sinusuportahan.',
        logoUploadFailed: 'Hindi na-upload ang logo ng kumpanya.',
        logoUnavailable: 'Hindi available ang logo file. I-upload itong muli.',
        deleteAccount: 'I-delete ang account',
        deleteAccountDescription: 'Permanenteng isara ang iyong Swift Invoice account.',
        deleteAccountTitle: 'I-delete ang account?',
        deleteAccountWarning: 'Hindi na mababawi ang aksyong ito.',
        deleteAccountConfirm: 'Ilagay ang iyong password upang kumpirmahin ang pag-delete ng account.',
        deleteAccountPasswordPlaceholder: 'Ilagay ang iyong password'
    },
    menu: {
        openNavigation: 'Buksan ang nabigasyon',
        closeNavigation: 'Isara ang nabigasyon',
        invoices: 'Mga Invoice',
        estimates: 'Mga Estimate',
        purchaseOrders: 'Purchase Orders',
        creditMemos: 'Mga Credit Memo',
        time: 'Oras',
        items: 'Mga Item',
        clients: 'Mga Kliyente',
        expenses: 'Mga Gastos',
        reports: 'Mga Report',
        settings: 'Mga Setting',
        companyInfo: 'Impormasyon ng kumpanya',
        taxes: 'Mga Buwis',
        default: 'Default',
        customizeInvoice: 'I-customize ang invoice',
        sendFeedback: 'Magpadala ng Feedback',
        newReply: '1 bagong tugon',
        signOut: 'Mag-sign out',
        signOutConfirm: 'Sigurado ka bang mag-sign out?',
        addBusiness: 'Magdagdag ng negosyo',
        newBusinessTitle: 'Bagong negosyo',
        businessName: 'Pangalan ng negosyo',
        businessNamePlaceholder: 'Ilagay ang pangalan ng negosyo',
        createBusiness: 'Gumawa',
        businessNameRequired: 'Ilagay ang pangalan ng negosyo',
        createBusinessSuccess: 'Matagumpay na nagawa ang negosyo',
        deleteBusiness: 'Tanggalin ang negosyo',
        deleteBusinessTitle: 'Tanggalin ang negosyo',
        deleteBusinessConfirm: 'Tanggalin ang “{name}”?',
        deleteBusinessWarning: 'Tatanggalin ang lahat ng data ng negosyong ito.',
        deleteBusinessSuccess: 'Matagumpay na natanggal ang negosyo',
        trialDaysLeft: 'May {days} araw pa sa trial',
        upgradeAccount: 'I-upgrade ang account'
    },
    network: {
        loginExpired: 'Nag-expire na ang login, mangyaring mag-log in muli',
        requestTimeout: 'Nag-time out ang request, mangyaring suriin ang network'
    },
    language: {
        label: 'Wika',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        listLoadFailed: 'Hindi ma-load ang mga invoice.',
        summaryLoadFailed: 'Hindi ma-load ang mga kabuuan ng invoice.',
        invoiceNumberPlaceholder: 'Ilagay ang numero ng invoice',
        filterAllClients: 'Lahat ng kliyente',
        clientOptionsLoadFailed: 'Hindi ma-load ang mga kliyente para sa pag-filter.',
        filterAllStatuses: 'Lahat ng status',
        filterUnpaid: 'Hindi bayad',
        filterPaid: 'Bayad',
        filterOverdue: 'Lagpas sa takdang petsa',
        filterUnsent: 'Hindi naipadala',
        filterSent: 'Naipadala',
        filterStartDate: 'Petsa ng simula',
        filterEndDate: 'Petsa ng pagtatapos',
        searchPlaceholder: 'Maghanap sa iyong mga invoice',
        addInvoice: 'Magdagdag ng invoice',
        overdueInvoices: 'Mga invoice na overdue',
        paidInvoices: 'Mga invoice na nabayaran',
        unpaidInvoices: 'Mga invoice na hindi nabayaran',
        unsentInvoices: 'Mga invoice na hindi pa naipapadala',
        columnNumber: 'Numero',
        columnClient: 'Kliyente',
        columnStatus: 'Status',
        statusFullyPaid: 'Lubusang nabayaran',
        statusPartial: 'Bahagya',
        statusOverdue: 'Overdue',
        statusUnsent: 'Hindi Pa Naipapadala',
        statusSent: 'Naipadala',
        statusOpened: 'Nabuksan',
        actionRecordPayment: 'Itala ang Pagbabayad',
        actionMarkAsSent: 'Markahan bilang Naipadala',
        actionCopy: 'Kopyahin',
        actionDelete: 'Tanggalin',
        copyDialogTitle: 'Kopyahin ang invoice',
        copyTargetType: 'Kopyahin sa',
        copyOptions: 'Mga opsyon sa pagkopya',
        copyClient: 'Kopyahin ang client',
        copyItems: 'Kopyahin ang mga item',
        copyAttachments: 'Kopyahin ang mga attachment',
        confirmDelete: 'Tanggalin itong invoice. Magpatuloy?',
        copySuccess: 'Invoice nakopya',
        copyFailed: 'Nabigong kopyahin',
        deleteSuccess: 'Invoice tinanggal',
        deleteFailed: 'Nabigong tanggalin',
        recordPaymentDialogTitle: 'Itala ang Pagbabayad',
        markAsFullyPaid: 'Markahan bilang lubusang nabayaran',
        formAmount: 'Halaga',
        formDate: 'Petsa',
        formPaymentMethod: 'Paraan ng Pagbabayad',
        formNote: 'Tala',
        allYears: 'Lahat ng taon',
        errorNoOutstandingBalance: 'Walang natitirang balanseng maaaring bayaran',
        errorInvalidPaymentAmount: 'Maglagay ng halagang higit sa zero na may hanggang 5 decimal place',
        dueDateToday: 'Ngayon',
        dueDateDaysAgo: '{days} araw ang nakalipas',
        dueDateInDays: 'sa {days} araw'
    },
    estimate: {
        filterAllStatuses: 'Lahat ng status',
        pageTitlePurchaseOrders: 'Mga Purchase Order',
        pageTitleEstimates: 'Mga Estimate',
        pageTitleCreditMemos: 'Mga Credit Memo',
        searchPlaceholderPurchaseOrders: 'Maghanap sa iyong mga purchase order',
        searchPlaceholderEstimates: 'Maghanap sa iyong mga estimate',
        searchPlaceholderCreditMemos: 'Maghanap sa iyong mga credit memo',
        addPurchaseOrder: 'Magdagdag ng purchase order',
        addEstimate: 'Magdagdag ng estimate',
        addCreditMemo: 'Magdagdag ng credit memo',
        columnNumber: 'Numero',
        columnClient: 'Kliyente',
        columnDate: 'Petsa',
        columnEmail: 'Email',
        columnStatus: 'Status',
        columnTotal: 'Kabuuan',
        statusUnsent: 'Hindi Pa Naipapadala',
        statusSent: 'Naipadala',
        actionMarkAsSent: 'Markahan bilang Naipadala',
        actionCopy: 'Kopyahin',
        actionDelete: 'Tanggalin',
        actionConvertToInvoice: 'I-convert sa invoice',
        copyDialogTitle: 'Kopyahin ang {document}',
        copyTargetType: 'Kopyahin sa',
        copyOptions: 'Mga opsyon sa pagkopya',
        copyClient: 'Kopyahin ang client',
        copyItems: 'Kopyahin ang mga item',
        copyAttachments: 'Kopyahin ang mga attachment',
        confirmDelete: 'Tanggalin itong {document}. Magpatuloy?',
        convertConfirm: 'I-convert itong {document} sa invoice? Ang petsa ay ilalagay sa ngayon.',
        copySuccess: '{document} nakopya',
        copyFailed: 'Nabigong kopyahin',
        convertSuccess: '{document} na-convert sa invoice',
        convertFailed: 'Nabigong i-convert',
        deleteSuccess: '{document} tinanggal',
        deleteFailed: 'Nabigong tanggalin',
        dueDateToday: 'Ngayon',
        dueDateDaysAgo: '{days} araw ang nakalipas',
        dueDateInDays: 'sa {days} araw'
    },
    item: {
        pageTitle: 'Mga Item',
        searchPlaceholder: 'Maghanap sa iyong mga item',
        addItem: 'Magdagdag ng item',
        columnInventoryCountUnit: 'Bilang ng Imbentaryo/Yunit',
        noDescription: 'WALANG PAGLALARAWAN NG ITEM'
    },
    client: {
        detailsTitle: 'Mga detalye ng kliyente',
        contactDetails: 'Impormasyon sa pakikipag-ugnayan',
        invoiceHistory: 'Kasaysayan ng invoice',
        noInvoices: 'Wala pang invoice',
        retry: 'Subukang muli',
        detailsLoadFailed: 'Hindi ma-load ang mga detalye ng kliyente.',
        invoicesLoadFailed: 'Hindi ma-load ang mga invoice.',
        deleteConfirm: 'I-delete ang kliyenteng ito?',
        deleted: 'Na-delete ang kliyente',
        pageTitle: 'Mga Kliyente',
        searchPlaceholder: 'Maghanap sa iyong mga kliyente',
        addClient: 'Magdagdag ng kliyente',
        columnClientName: 'Pangalan ng Kliyente',
        columnEmail: 'Email',
        columnPhone: 'Telepono',
        columnBalanceDue: 'Balanse na Dapat Bayaran',
        noNameFallback: 'WALANG PANGALAN'
    },
    expense: {
        pageTitle: 'Mga Gastos',
        searchPlaceholder: 'Maghanap sa iyong mga gastos',
        allCategories: 'Lahat ng kategorya',
        noCategory: 'Walang Kategorya',
        categoryLoadFailed: 'Hindi ma-load ang mga kategorya ng gastos.',
        addExpense: 'Magdagdag ng gastos',
        columnDescription: 'Paglalarawan',
        columnDate: 'Petsa',
        columnTotal: 'Kabuuan',
        tip: 'Tip'
    },
    report: {
        headerTitle: 'Mga Report',
        tabDashboard: 'Dashboard',
        tabReportList: 'Listahan ng report',
        export: 'I-export',
        annualSalesByClient: 'Taunang benta ayon sa kliyente',
        otherClients: 'Iba pang kliyente',
        totalOutstandingBalance: 'Kabuuang hindi pa nababayarang balanse',
        invoicesCountSuffix: 'mga invoice',
        byMonth: 'Ayon sa buwan',
        byQuarter: 'Ayon sa quarter',
        noSalesFound: 'Walang nahanap na benta',
        filterReportTypes: 'Mga uri ng report',
        filterTimePeriod: 'Panahon',
        filterView: 'Tingnan',
        filterTaxYear: 'Taon ng buwis',
        filterQuarter: 'Quarter',
        filterMonth: 'Buwan',
        filterStartDate: 'Petsa ng simula',
        filterEndDate: 'Petsa ng pagtatapos',
        invalidCustomDateRange: 'Hindi maaaring mas huli ang petsa ng simula kaysa petsa ng pagtatapos',
        searchClientName: 'Maghanap ng pangalan ng client',
        searchItemName: 'Maghanap ng pangalan ng item',
        searchSalesJournal: 'Maghanap ng invoice number o pangalan ng client',
        searchPaymentsJournal: 'Maghanap ng invoice number, pangalan ng client, o uri ng bayad',
        periodMonth: 'Buwan',
        periodQuarter: 'Quarter',
        periodYear: 'Taon',
        periodAllTaxYears: 'Lahat ng Taon ng Buwis',
        periodCustom: 'Pasadya',
        taxYearLabel: 'Taon ng Buwis {year}',
        quarterLabel: 'Q{quarter} Taon ng Buwis {year}',
        optionMonthly: 'Buwanan',
        optionQuarterly: 'Quarterly',
        customerAgingTitle: 'Customer Aging',
        noDataForDateRange: 'Walang data para sa panahong ito',
        typeSalesByDate: 'Benta ayon sa Petsa',
        typeSalesByClient: 'Benta ayon sa Kliyente',
        typeSalesByItem: 'Benta ayon sa Item',
        typeSalesJournal: 'Journal ng Benta',
        typePaymentsByDate: 'Pagbabayad ayon sa Petsa',
        typePaymentsByClient: 'Pagbabayad ayon sa Kliyente',
        typePaymentsByType: 'Pagbabayad ayon sa Uri',
        typePaymentsJournal: 'Journal ng Pagbabayad',
        typeExpenseByCategory: 'Gastos ayon sa Kategorya',
        typeExpenseJournal: 'Journal ng Gastos',
        typeProfitLoss: 'Kita at Lugi',
        typeTaxes: 'Mga Buwis',
        typeCustomerAging: 'Customer Aging',
        allYears: 'Lahat ng taon',
        allTime: 'Lahat ng oras',
        allSales: 'Lahat ng benta',
        taxYearSales: 'Benta ng tax year {year}',
        firstColumnMonth: 'Buwan',
        firstColumnQuarter: 'Quarter',
        firstColumnYear: 'Taon',
        firstColumnDay: 'Araw',
        firstColumnDate: 'Petsa',
        columnSubTotal: 'Sub Total',
        columnTax: 'Buwis',
        columnDiscount: 'Diskwento',
        columnTotal: 'Kabuuan',
        columnAmountPaid: 'Nabayarang Halaga',
        columnAmountOwed: 'Utang na Halaga',
        columnClient: 'Kliyente',
        columnItem: 'Item',
        columnUnitType: 'Uri ng Yunit',
        columnQuantity: 'Dami',
        columnRateAvg: 'Rate (avg)',
        columnInvoiceDate: 'Petsa ng Invoice',
        columnInvoiceNo: 'Invoice No',
        columnType: 'Uri',
        columnPaymentDate: 'Petsa ng Pagbabayad',
        columnCategory: 'Kategorya',
        columnExpenseDate: 'Petsa ng Gastos',
        columnMerchant: 'Merchant',
        columnDescription: 'Paglalarawan',
        columnCurrentDue: 'Kasalukuyang Dapat Bayaran',
        column1To30DaysOverdue: '1-30 Araw na Overdue',
        column31To60DaysOverdue: '31-60 Araw na Overdue',
        column61To90DaysOverdue: '61-90 Araw na Overdue',
        column91PlusDaysOverdue: '91+ Araw na Overdue',
        columnSection: 'Seksyon',
        columnAmount: 'Halaga',
        columnPreTaxSales: 'Benta Bago ang Buwis',
        columnTaxLabel: 'Pangalan ng Buwis',
        columnTaxRate: 'Rate ng Buwis',
        columnTotalTax: 'Kabuuang Buwis',
        columnPostTaxTotal: 'Kabuuan Pagkatapos ng Buwis',
        profitLossTitle: 'Kita at Lugi',
        taxesTitle: 'Mga Buwis',
        profitLossRevenue: 'Kita',
        profitLossExpense: 'Gastos',
        profitLossProfit: 'Tubo',
        profitLossCash: 'Cash',
        profitLossAccrued: 'Naipon',
        profitLossAccountsReceivables: 'Mga Account na Matatanggap',
        profitLossNone: '[Wala]',
        profitLossTotalExpenses: 'Kabuuang Gastos',
        profitLossCashProfit: 'Tubong Cash',
        profitLossAccruedProfit: 'Naipong Tubo',
        monthNames: 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec',
        totalRowLabel: 'Kabuuan'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Magdagdag',
        initialDataLoadFailed: 'Hindi ma-load ang mga setting ng dokumento. Naka-disable ang pag-edit at pag-save.',
        searchSuggestionsLoadFailed: 'Hindi ma-load ang mga mungkahi sa paghahanap.',
        invoicePrefix: 'prefix ng invoice',
        tabCreate: 'Lumikha',
        tabPreview: 'Preview',
        tabSendEmail: 'Magpadala ng Email',
        sectionClient: 'Kliyente',
        addClient: 'Magdagdag ng kliyente',
        dialogClientInfo: 'Impormasyon ng kliyente',
        basicInformation: 'Pangunahing impormasyon',
        labelName: 'Pangalan',
        labelEmail: 'Email',
        labelPhone: 'Telepono',
        billingAddress: 'Address ng pagbabayad',
        labelLine1: 'Linya 1',
        labelLine2: 'Linya 2',
        labelLine3: 'Linya 3',
        shippingAddress: 'Address ng pagpapadala',
        labelShippingName: 'Pangalan sa Pagpapadala',
        labelNotes: 'Mga Tala',
        placeholderCreateOrSelect: 'Lumikha o pumili ng isa...',
        placeholderClientNotes: "Magdagdag ng tala tungkol sa kliyente. Hindi nila makikita ito",
        sectionItems: 'Mga Item',
        saveToYourItem: 'I-save sa iyong item',
        stock: 'Stock:',
        placeholderItemCode: 'code ng item',
        placeholderQuantity: 'Dami',
        placeholderRate: 'rate',
        placeholderInputDescription: 'Ilagay ang paglalarawan',
        placeholderInputComment: 'Ilagay ang Komento',
        placeholderAddRecipient: 'Magdagdag ng tatanggap',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'Paksa ng email',
        placeholderMessage: 'Isulat ang iyong mensahe...',
        labelTo: 'Kay',
        labelSubject: 'Paksa',
        sectionAttachments: 'Mga Kalakip',
        sectionComment: 'Komento',
        addItem: 'Magdagdag ng item',
        addPhoto: 'Magdagdag ng larawan',
        addPayment: 'Magdagdag ng pagbabayad',
        goBack: 'bumalik',
        dialogShippingInfo: 'Impormasyon ng pagpapadala',
        dialogRecordPayment: 'Itala ang Pagbabayad',
        dialogJobDetails: 'Mga detalye ng trabaho',
        labelAmount: 'Halaga',
        labelShipDate: 'Petsa ng pagpapadala',
        labelShipVia: 'Ipadala sa pamamagitan ng',
        labelTrackingNumber: 'Numero ng tracking',
        labelFob: 'FOB',
        columnDate: 'Petsa',
        columnType: 'Uri',
        msgClientEmailError: 'error sa email ng kliyente',
        msgAmountGreaterThanZero: 'Dapat mas malaki sa zero ang halaga',
        msgInvalidAmount: 'Ang halaga ay dapat mula 0 hanggang 999,999,999,999,999 at may hanggang 5 decimal place',
        calculatedAmountOutOfRange: 'Lampas sa sinusuportahang saklaw ang nakalkulang halaga',
        msgTextTooLong: 'Hindi maaaring lumampas sa {max} character ang {field}',
        msgTextTooLongBytes: 'Hindi maaaring lumampas sa {max} UTF-8 byte ang {field}',
        msgInvalidJobDetails: 'May hindi wastong data ang mga detalye ng trabaho',
        msgMorePaymentThanBalance: 'Mas maraming bayad kaysa sa balanse na dapat bayaran',
        mailSentSuccessfully: 'Matagumpay na naipadala ang email',
        cumulativeTaxNotice: 'Hindi sinusuportahan ng web ang pagkaipon ng buwis sa invoice...',
        confirmUnsavedChanges: 'Mayroon kang mga hindi na-save na pagbabago. Gusto mo ba itong i-save o itapon?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Buwis, diskwento at withholding',
        purchaseOrder: 'Purchase Order',
        placeholderPurchaseOrderPrefix: 'prefix ng purchase order',
        placeholderCreditMemoPrefix: 'prefix ng credit memo',
        placeholderEstimatePrefix: 'prefix ng estimate',
        labelStatus: 'Status',
        statusIssued: 'Inisyu',
        statusApproved: 'Aprubado',
        statusPending: 'Nakabinbin',
        statusWithdrawn: 'Binitiw',
        tax: 'Buwis'
    },
    createEstimate: {
        pageTitlePrefix: 'Magdagdag',
        cumulativeTaxNotice: 'Hindi sinusuportahan ng web ang pagkaipon ng buwis sa estimate...'
    },
    updateInvoice: {
        pageTitlePrefix: 'I-update',
        deletePrefix: 'Tanggalin',
        confirmDelete: 'Tatanggalin nito ang invoice. Magpatuloy?',
        cumulativeTaxNotice: 'Naglalaman ang invoice na ito ng cumulative tax. Hindi pansamantalang sinusuportahan ng web ang function na ito'
    },
    updateEstimate: {
        pageTitlePrefix: 'I-update',
        deletePrefix: 'Tanggalin',
        confirmDelete: 'Tatanggalin nito ang {document}. Magpatuloy?',
        cumulativeTaxNotice: 'Naglalaman ang estimate na ito ng cumulative tax. Hindi pansamantalang sinusuportahan ng web ang function na ito'
    },
    createAccount: {
        title: 'Lumikha ng Account',
        placeholderEmail: 'email',
        placeholderPassword: 'Password',
        placeholderCompanyName: 'Pangalan ng Kumpanya',
        createAccountButton: 'Lumikha ng account',
        alreadyHaveAccount: 'Mayroon nang account?',
        signIn: 'Mag-sign in',
        validEmail: 'Mangyaring maglagay ng tamang email address',
        validPassword: 'Dapat ay 6 o higit pang character ang password',
        validCompanyName: 'Mangyaring punan ang pangalan ng iyong kumpanya',
        companyNameTooLong: 'Maaaring magkaroon ng hanggang {max} character ang pangalan ng kumpanya'
    },
    clientCreate: {
        pageTitle: 'Magdagdag ng kliyente',
        basicInformation: 'Pangunahing impormasyon',
        labelName: 'Pangalan',
        placeholderName: 'Maglagay ng pangalan...',
        labelEmail: 'Email',
        placeholderEmail: 'Maglagay ng email address...',
        labelPhone: 'Telepono',
        placeholderPhone: 'Maglagay ng numero ng telepono...',
        billingAddress: 'Address ng pagbabayad',
        labelLine1: 'Linya 1',
        labelLine2: 'Linya 2',
        labelLine3: 'Linya 3',
        shippingAddress: 'Address ng pagpapadala',
        sameAsBilling: 'Katulad ng address ng pagbabayad',
        labelShippingName: 'Pangalan sa pagpapadala',
        labelShippingLine1: 'Linya 1',
        labelShippingLine2: 'Linya 2',
        labelShippingLine3: 'Linya 3',
        labelNotes: 'Mga Tala',
        placeholderNotes: "Magdagdag ng tala tungkol sa kliyente. Hindi nila makikita ito",
        defaultDiscount: 'Default na diskwento',
        validDefaultDiscount: 'Maglagay ng wastong default na diskwento',
        validName: 'Mangyaring maglagay ng pangalan ng kliyente',
        validEmail: 'Mangyaring maglagay ng tamang email address'
    },
    clientUpdate: {
        pageTitle: 'I-update ang kliyente',
        confirmDelete: 'Tatanggalin nito ang kliyente. Magpatuloy?'
    },
    itemCreate: {
        pageTitle: 'Magdagdag ng item',
        itemTitle: 'Item',
        labelCost: 'Gastos',
        rateSign: 'Tanda ng rate',
        inventorySign: 'Tanda ng pagsasaayos ng imbentaryo',
        labelUnit: 'Yunit',
        placeholderUnit: 'Yunit',
        defaultTaxes: 'Default na mga buwis',
        taxOff: 'off',
        inventoryTitle: 'Imbentaryo',
        currentInventory: 'Kasalukuyang imbentaryo',
        adjustInventory: 'I-adjust ang imbentaryo',
        increase: 'Dagdagan',
        decrease: 'Bawasan',
        placeholderQuantity: 'Dami',
        placeholderDateAndTime: 'Petsa at oras',
        placeholderNote: 'Tala',
        addButton: 'Idagdag',
        columnDate: 'Petsa',
        columnQuantity: 'Dami',
        columnNote: 'Tala',
        withholdingTitle: 'Withholding',
        msgInventoryCannotDisable: 'Hindi maaaring i-disable ang imbentaryo kapag ito ay na-enable na',
        msgDescriptionRequired: 'Kailangan ang paglalarawan ng item',
        msgInvalidRate: 'Ang rate ay dapat nasa pagitan ng -999,999,999,999,999 at 999,999,999,999,999 at hanggang 4 na decimal place',
        msgInvalidCost: 'Ang gastos ay dapat nasa pagitan ng 0 at 999,999,999,999,999 at hanggang 5 decimal place',
        msgInvalidInventory: 'Ang dami ay dapat nasa pagitan ng 0 at 999,999,999,999,999 at hanggang 5 decimal place',
        msgInvalidUnit: 'Hindi maaaring maglaman ng && o lumampas sa 255 character ang yunit',
        msgQuantityRequired: 'Kailangan ang dami',
        msgDateRequired: 'Kailangan ang petsa at oras'
    },
    itemUpdate: {
        pageTitle: 'I-edit ang item',
        columnInvoice: 'Invoice',
        confirmDelete: 'Tatanggalin nito ang item. Magpatuloy?'
    },
    createStatement: {
        pageTitle: 'Statement',
        tabPreview: 'Preview',
        tabSendEmail: 'Magpadala ng Email',
        createAction: 'Gumawa ng Statement',
        from: 'Mula',
        to: 'Hanggang',
        invoices: 'Mga invoice',
        balanceDue: 'Natitirang balanse',
        editTitle: 'I-edit ang Statement',
        startDate: 'Petsa ng simula',
        endDate: 'Petsa ng pagtatapos',
        onlyShowUnpaid: 'Ipakita lamang ang mga hindi pa bayad na invoice',
        unpaidOnlyActive: 'Mga hindi pa bayad na invoice lamang ang kasama sa statement na ito.',
        dateRequired: 'Kailangan ang petsa ng simula at pagtatapos',
        invalidDateRange: 'Hindi maaaring mas maaga ang petsa ng pagtatapos kaysa petsa ng simula'
    },
    time: {
        pageTitle: 'Oras',
        unbilled: 'Hindi pa nasingil',
        billed: 'Nasingil na',
        searchPlaceholder: 'Maghanap ayon sa kliyente o paglalarawan',
        addTime: 'Magdagdag ng oras',
        noTime: 'Walang tala ng oras',
        noTimeDescription: 'Gumawa ng tala upang subaybayan ang trabahong maaaring singilin.',
        noClient: 'Walang kliyente',
        filterAndSort: 'I-filter at ayusin',
        year: 'Taon',
        groupBy: 'Pangkatin ayon sa',
        sortBy: 'Ayusin ayon sa',
        order: 'Pagkakasunod-sunod',
        yearly: 'Taunan',
        quarterly: 'Kada quarter',
        monthly: 'Buwanan',
        ascending: 'Pataas',
        descending: 'Pababa',
        duration: 'Tagal',
        createTitle: 'Gumawa ng tala ng oras',
        editTitle: 'Oras',
        selectClient: 'Pumili ng kliyente',
        start: 'Simula',
        end: 'Wakas',
        hours: 'oras',
        minutes: 'minuto',
        ratePreset: 'Rate',
        customRate: 'Pasadyang rate',
        rateName: 'Pangalan ng rate',
        showRateName: 'Ipakita ang pangalan ng rate sa invoice',
        invalidDate: 'Kinakailangan ang oras ng simula at wakas',
        endBeforeStart: 'Hindi maaaring mauna ang oras ng wakas sa oras ng simula',
        invalidDuration: 'Dapat tumugma ang tagal sa oras ng simula at wakas',
        invalidRate: 'Ang rate ay dapat nasa 0 hanggang 999999999999999 at may hanggang 5 decimal place',
        rateNameTooLong: 'Hindi maaaring lumampas sa 255 character ang pangalan ng rate',
        descriptionTooLong: 'Hindi maaaring lumampas sa 3000 character ang paglalarawan',
        confirmDelete: 'Tatanggalin ang tala ng oras na ito. Magpatuloy?'
    },
    setting: {
        taxInfo: 'Impormasyon ng Buwis',
        taxes: 'Mga Buwis',
        taxYearStarts: 'Simula ng tax year',
        taxYearStartSubtitle: 'Itakda ang unang araw ng financial year',
        rateLabel: 'Rate(%)',
        abbreviation: 'Abbreviation',
        addTax: 'Magdagdag ng buwis',
        month: 'Buwan',
        day: 'Araw',
        monthPlaceholder: 'Buwan',
        dayPlaceholder: 'Araw',
        saveTaxYearStart: 'I-save',
        deleteDialogTitle: 'Tanggalin',
        confirmDeleteTax: 'Sigurado ka bang tanggalin ang buwis na ito?',
        deleteConfirm: 'Tanggalin',
        taxInfoDialogTitle: 'Impormasyon ng Buwis',
        taxName: 'Pangalan ng Buwis',
        standardRate: 'Standard na rate (%)',
        additionalRate: 'Karagdagang rate',
        deleteRateX: 'X',
        addRate: 'Magdagdag ng rate',
        taxType: 'Uri ng buwis',
        exclusive: 'Exclusive',
        inclusive: 'Inclusive',
        close: 'isara',
        saveTax: 'I-save ang buwis',
        cantOpenDetailMessage: 'Naglalaman ang buwis na ito ng cumulative tax. Hindi pansamantalang sinusuportahan ng web ang function na ito',
        closeButton: 'Isara',
        rateIsRequired: 'kailangan ang rate',
        rateIsRequiredMsg: 'Kailangan ang rate',
        monthAndDayRequired: 'Kailangan ang buwan at araw',
        additionalRateNumber: 'Karagdagang rate {number} (%)',
        taxNameRequired: 'Kinakailangan ang pangalan ng buwis',
        invalidTaxRate: 'Ang rate ay dapat nasa 0 hanggang 999999999999999 at may hanggang 4 na decimal place',
        duplicateTaxRate: 'Dapat natatangi ang mga rate ng buwis',
        taxRatesTooLong: 'Masyadong maraming rate ng buwis upang i-save',
        withholdingNameRequired: 'Kinakailangan ang daglat kapag aktibo ang withholding',
        moreRate: ' karagdagang rate',
        moreRates: ' karagdagang mga rate'
    },
    companyInfo: {
        title: 'Impormasyon ng Kumpanya',
        details: 'Mga Detalye',
        businessName: 'Pangalan ng negosyo',
        businessNamePlaceholder: 'Pangalan ng negosyo',
        name: 'Pangalan',
        phone: 'Telepono',
        email: 'Email',
        businessNumber: 'Numero ng Negosyo',
        taxNo: 'Tax N°',
        deleteField: 'tanggalin',
        addNewField: 'Magdagdag ng bagong field',
        address: 'Address',
        line1: 'Linya 1',
        line2: 'Linya 2',
        line3: 'Linya 3',
        currency: 'Currency',
        currencyLabel: 'Currency',
        symbol: 'Simbolo',
        placement: 'Pagkakalagay',
        before: 'Bago',
        after: 'Pagkatapos',
        thousandSymbol: 'Simbolo ng Libo',
        decimalSymbol: 'Simbolo ng Decimal',
        decimalPlaces: 'Mga Decimal Place',
        example: 'Halimbawa',
        terms: 'Mga Tuntunin',
        termsLabel: 'Mga Tuntunin',
        termSameDay: 'Araw ding Ito',
        term7Days: '7 Araw',
        term14Days: '14 Araw',
        term21Days: '21 Araw',
        term30Days: '30 Araw',
        term45Days: '45 Araw',
        term60Days: '60 Araw',
        term90Days: '90 Araw',
        term180Days: '180 Araw',
        term365Days: '365 Araw',
        paymentInfo: 'Impormasyon ng Pagbabayad',
        displayOnInvoices: 'Ipakita sa mga invoice',
        titlePlaceholder: 'Pamagat',
        jobDetails: 'Mga Detalye ng Trabaho',
        deleteJobDetail: 'tanggalin',
        addNewJobField: 'magdagdag ng bagong field',
        fieldNameRequired: '{field}: kailangan ang pangalan ng field',
        reservedCharacters: '{field}: hindi maaaring maglaman ng : o && ang pangalan, at hindi maaaring maglaman ng && ang value',
        serializedDataTooLong: 'Lumampas sa limitasyon ng database ang data ng {field}',
        textDataTooLong: 'Lumampas sa limitasyon ng database ang {field}'
    },
    default: {
        title: 'Default',
        emailMessage: 'Mensahe ng Email',
        enterDescription: 'Maglagay ng paglalarawan',
        emailCc: 'Email Cc',
        emailBcc: 'Email Bcc',
        emailTip: 'Magpadala ng email sa parehong oras sa address sa itaas.',
        defaultComments: 'Default na Komento',
        invoice: 'Invoice',
        estimate: 'Estimate',
        purchaseOrder: 'Purchase Order',
        creditMemo: 'Credit Memo',
        emailValidError: 'tamang email'
    },
    invoiceDesign: {
        template: 'Template',
        color: 'Kulay',
        labels: 'Mga Label',
        labelInvoice: 'Invoice',
        labelEstimate: 'Estimate',
        labelPurchaseOrder: 'Purchase order',
        labelCreditMemo: 'Credit memo',
        labelReceipt: 'RECEIPT',
        labelTermsFormat: 'Format ng tuntunin',
        labelBillTo: 'Ibabayad ni',
        labelFor: 'Para sa',
        labelDate: 'Petsa',
        labelInvoiceNo: 'Invoice no',
        labelEstimateNo: 'Estimate no',
        labelPoNo: 'PO no',
        labelCreditMemoNo: 'Credit memo no',
        labelDueDate: 'Petsa ng pagbabayad',
        labelTerms: 'Mga Tuntunin',
        labelAmount: 'Halaga',
        labelCode: 'Code',
        labelDescription: 'Paglalarawan',
        labelQuantity: 'Dami',
        labelRate: 'Rate',
        labelTax: 'Buwis',
        labelSubtotal: 'Subtotal',
        labelBalanceDue: 'Balanse na dapat bayaran',
        labelDiscount: 'Diskwento',
        labelNonTaxableItem: 'Item na hindi kinakaltasan ng buwis',
        labelPaid: 'Nabayaran',
        labelShipping: 'Pagpapadala',
        labelTotal: 'Kabuuan',
        labelIncludes: 'Kasama',
        labelTotalAmountPaid: 'Kabuuang Nabayarang Halaga',
        labelShipDate: 'Petsa ng Pagpapadala',
        labelShipTo: 'Ipadala kay',
        labelShipVia: 'Ipadala sa pamamagitan ng',
        labelTrackingNo: 'Tracking no',
        labelFob: 'F.O.B',
        prefix: 'Prefix',
        prefixInvoice: 'Invoice',
        prefixEstimate: 'Estimate',
        prefixPurchaseOrder: 'Purchase Order',
        prefixCreditMemo: 'Credit Memo',
        nextNumber: 'Susunod na Numero',
        numberingBeginsAt: 'Magsisimula ang numero sa',
        nextNumberInvoice: 'Invoice',
        nextNumberEstimate: 'Estimate',
        nextNumberPurchaseOrder: 'Purchase Order',
        nextNumberCreditMemo: 'Credit Memo',
        options: 'Mga Opsyon',
        optionTerms: 'Mga Tuntunin',
        optionDueDate: 'Petsa ng Pagbabayad',
        optionShippingAddress: 'Address ng pagpapadala',
        optionProductCode: 'Code ng produkto',
        optionQuantityAndRate: 'Dami at rate',
        optionUnit: 'Yunit',
        optionTax: 'Buwis',
        optionAmount: 'Halaga',
        optionNonTaxableItemStar: 'Bituin sa item na hindi kinakaltasan ng buwis',
        optionDiscount: 'Ipakita ang diskuwento',
        optionTaxBreakdown: 'Pagkakahati ng Buwis',
        optionPaymentHistory: 'Kasaysayan ng pagbabayad',
        optionStamp: 'Stamp',
        optionPageNumber: 'Numero ng Pahina',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "Salamat sa iyong negosyo! Sana ay nasiyahan ka sa aming trabaho. Mangyaring magpadala ng bayad sa loob ng 15 araw.Mga tanong? Komento? Makipag-ugnayan sa amin sa(111)111-1234 o i-email sa example@owner.com, masaya kaming sagutin ang anumang tanong o alalahanin.",
        previewSubtotal: 'Subtotal',
        previewVat: 'VAT 17.00%',
        previewPayment1: 'Pagbabayad noong Oct 1, 2019',
        previewPayment2: 'Pagbabayad noong Oct 2, 2019',
        invalidNextNumber: 'Ang bawat susunod na numero ay dapat buong bilang mula 0 hanggang {max}'
    },
    feedback: {
        title: 'Magpadala ng Feedback',
        invalidEmailNoticePrefix: 'Di-wasto ang email address sa iyong account, kaya hindi ka namin makontak. Mangyaring ipadala ang iyong feedback mula sa wastong email address sa',
        invalidEmailNoticeSuffix: 'Kung posible, isama ang screenshot ng isyu; makakatulong ito sa amin na imbestigahan at malutas ito.',
        replyTip: 'Pagkatapos magpadala, mangyaring suriin ang iyong email para sa tugon.',
        contextTip: 'Isasama sa iyong feedback ang sumusunod na detalye ng account at browser:',
        content: 'Nilalaman',
        enterDescription: 'Maglagay ng paglalarawan',
        contentTooLong: 'Hindi maaaring lumampas sa {max} character ang nilalaman'
    },
    createExpense: {
        title: 'Magdagdag ng Gastos',
        description: 'Paglalarawan',
        expenseDescriptionPlaceholder: 'Paglalarawan ng gastos',
        total: 'Kabuuan',
        tax: 'Buwis',
        tip: 'Tip',
        expenseDate: 'Petsa ng Gastos',
        merchant: 'Merchant',
        merchantPlaceholder: 'Ilagay ang pangalan ng merchant',
        categoryPlaceholder: 'Pumili ng kategorya',
        addNewCategory: 'Magdagdag ng bagong kategorya',
        deletePhoto: 'Tanggalin',
        addPhoto: 'Magdagdag ng larawan',
        deleteCategory: 'tanggalin',
        addCategory: 'Magdagdag ng kategorya',
        descriptionTooLong: 'Hindi maaaring lumampas sa 3,000 character ang paglalarawan.',
        merchantTooLong: 'Hindi maaaring lumampas sa 255 character ang pangalan ng merchant.',
        amountInvalid: 'Ang total, buwis, at tip ay dapat nasa pagitan ng 0 at 999999999999999 at may hanggang 5 decimal place.',
        categoryRequired: 'Kailangan ang pangalan ng kategorya.',
        categoryTooLong: 'Hindi maaaring lumampas sa 255 character ang pangalan ng kategorya.',
        photoUploadFailed: 'Hindi na-upload ang larawan. Pakisubukang muli.'
    },
    updateExpense: {
        title: 'I-update ang Gastos',
        deleteExpense: 'Tanggalin ang Gastos',
        confirmDeleteMsg: 'Tatanggalin nito ang gastos. Magpatuloy?'
    },
    notFound: {
        oops: 'OOPS!',
        notFoundMsg: "Mukhang hindi namin mahanap ang pahina na hinahanap mo.",
        takeMeHome: 'Ibalik ako sa home'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Free Shipping',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Computer',
        previewItem2: 'Phone',
        previewItem3: 'Birthday cake',
        previewTaxRate: '17%',
        nonTaxableNote: '* Nagpapahiwatig ng item na hindi kinakaltasan ng buwis',
        thanksMessage: "Salamat sa iyong negosyo! Sana ay nasiyahan ka sa aming trabaho. Mangyaring magpadala ng bayad sa loob ng 15 araw.Mga tanong? Komento? Makipag-ugnayan sa amin sa(111)111-1234 o i-email sa example@owner.com, masaya kaming sagutin ang anumang tanong o alalahanin.",
        subtotal: 'Subtotal',
        vat: 'VAT 17.00%',
        payment1: 'Pagbabayad noong Oct 1, 2019',
        payment2: 'Pagbabayad noong Oct 2, 2019',
        balanceDue: 'Balanse na Dapat Bayaran'
    }
};
